const url = 'http://192.168.1.162:8087/gzy' // 本地
// const url = 'http://bisc2021.ganzhiyu.com/gzy' // 
// const url = 'https://ganzhiyu.com/newgzy' // 线上
// const url = 'https://ganzhiyu.com/testgzy' // 测试

export default url
